module.exports = __webpack_public_path__ + "img/service.d14b6caa.svg";